import { render } from "./TicketRowColorsSettingForm.vue?vue&type=template&id=269c9864"
import script from "./js/ticketRowColorsSettingForm.js?vue&type=script&lang=js&external"
export * from "./js/ticketRowColorsSettingForm.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__